import { Model } from '@singularsystems/neo-core';
import PortfolioBalanceLookup from './PortfolioBalanceLookup';
import SettlementExchangeRateLookup from './SettlementExchangeRateLookup';

export interface IGroupedBalance {
    incentiveSchemeId: number;

    instrumentId: number;

    allowedExerciseDays: number | null;
}

export default class CalculatorDataRequest {

    public groupedBalances: IGroupedBalance[] = [];

    public currencyExchangeRates: Model.PartialPlainObject<SettlementExchangeRateLookup>[] = [];

    // Client only properties / methods

    public static fromTrancheBalances(balances: PortfolioBalanceLookup[], currencyExchangeRates: Model.PartialPlainObject<SettlementExchangeRateLookup>[]) {
        const request = new CalculatorDataRequest();

        request.currencyExchangeRates = currencyExchangeRates;

        const grouped = balances.groupBy(b => `${b.incentiveSchemeId}.${b.instrumentId}.${b.allowedExerciseDays ?? -1}`, (key, item) => item);
        request.groupedBalances = grouped.map(g => ({
            incentiveSchemeId: g.incentiveSchemeId,
            instrumentId: g.instrumentId,
            allowedExerciseDays: g.allowedExerciseDays
        }));

        return request;
    }
}